<template>
  <div class="header">
    <div @click="onBack" class="back">
      <img width="15px" src="../../image/imgs/fanhui.png" />
    </div>
    <div class="bar-wrapper" @click="handleFair">
      <div class="bar-img">
        <img
          round
          width="100%"
          height="100%"
          :src="robotInfo.header_img?robotInfo.header_img:''"
        />
      </div>
      <div class="bar-content">
        <div class="bar-title">Hi,我是{{robotInfo.robot_name ? robotInfo.robot_name : '客服助手'}}</div>
        <div
          class="bar-description"
        >{{robotInfo.robot_description?robotInfo.robot_description:'人工智能大模型AI+人工客服'}}</div>
      </div>
    </div>
    
    <!-- TTS 自动播报开关 -->
    <div class="tts-switch" :class="{ active: ttsAutoPlay }" @click.stop="toggleTTS">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
        <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/>
        <path v-if="ttsAutoPlay" d="M19.07 4.93a10 10 0 0 1 0 14.14"/>
        <path v-if="ttsAutoPlay" d="M15.54 8.46a5 5 0 0 1 0 7.07"/>
        <line v-if="!ttsAutoPlay" x1="23" y1="9" x2="17" y2="15"/>
        <line v-if="!ttsAutoPlay" x1="17" y1="9" x2="23" y2="15"/>
      </svg>
      <span>{{ ttsAutoPlay ? '播报开' : '播报关' }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  components: {},
  props: {
    robotInfo: {
      type: Object
    },
    ttsAutoPlay: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {
    handleFair() {
      this.$router.push({
        path: "/fairInfo/" + this.robotInfo?.robot_code
      });
    },
    onBack() {
      this.$emit("onBack");
    },
    toggleTTS() {
      this.$emit("toggleTTS");
    }
  }
};
</script>

<style scoped lang="less">
.header {
  background: url("../../image/imgs/chat-bg.jpg") fixed top no-repeat;
  background-size: 100%;
  height: 80px;
  position: relative;
  .back {
    display: flex;
    align-items: center;
    position: absolute;
    top: 20px;
    left: 10px;
    font-weight: 600;
  }
  .bar-wrapper {
    position: absolute;
    display: flex;
    align-items: center;
    bottom: 0px;
    left: 20px;
    .bar-img {
      width: 20%;
      max-width: 45px;
      margin: 0 10px;
    }
    .bar-content {
      width: 80%;
    }
    .bar-title {
      font-weight: 550;
      font-size: 14px;
      margin: 5px 0;
    }
    .bar-description {
      color: rgb(131, 131, 131);
      font-size: 12px;
      margin: 5px 0;
      letter-spacing: 1px;
      line-height: 14px;
    }
  }
  
  /* TTS 自动播报开关 */
  .tts-switch {
    position: absolute;
    bottom: 10px;
    right: 12px;
    z-index: 10;
    display: flex;
    align-items: center;
    gap: 5px;
    background: rgba(255, 255, 255, 0.9);
    border: 1px solid #d0d7e8;
    border-radius: 20px;
    padding: 5px 10px 5px 8px;
    cursor: pointer;
    user-select: none;
    font-size: 12px;
    color: #555;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
    transition: background 0.2s, color 0.2s;
    &.active {
      background: #1d6aff;
      color: #fff;
      border-color: #1d6aff;
    }
  }
}
</style>
